/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  components_use.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from 'vue'
import {
  Button,
  Cell,
  Icon,
  Checkbox,
  Image,
  CheckboxGroup,
  Field,
  Radio,
  RadioGroup,
  Search,
  Sticky,
  Popup,
  Picker,
  NumberKeyboard,
  Dialog,
  Loading,
  Toast,
  PullRefresh,
  List,
  NoticeBar,
  Grid,
  GridItem,
  Tab,
  Tabs,
  Col,
  Row,
  NavBar,
  Step,
  Steps,
  Tabbar,
  TabbarItem,
  CellGroup,
  Progress,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Calendar,
  Lazyload,
  Form,
  DatetimePicker,
  Uploader,
  Overlay,
  ActionSheet,
  Tag,
  Popover,
  Divider,
  Stepper,
  Slider,
  Cascader,
  Switch,
  SwipeCell,
  Badge,
  TreeSelect,
  Swipe,
  SwipeItem, Notify,
  Empty,
  Circle,
  CountDown,
  Sidebar,
  SidebarItem,
  Skeleton
} from 'vant'
// 引入阿里巴巴矢量图库
import '@/assets/fonts/iconfont.js'
import { downloadUrl, formatterNum, checkIsEmpty } from '@/utils/util'
/**
 * 全局引入字体图标组件
 * 使用方法：<icon-font type="icon-folder"></icon-font>
 */
import IconFont from '@/components/IconFont/index.vue'
import CommonLabel from '@/components/CommonLabel/index.vue'
import BackNav from '@/components/BackNav/index.vue'
import BackNavStore from '@/components/BackNavStore/index.vue'
import EmptyData from '@/components/Empty/index.vue'
import Message from '@/components/Message/index.vue'
import SearchNav from '@/components/SearchNav/index.vue'

Vue.use(Button)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Cell)
Vue.use(Icon)
Vue.use(Stepper)
Vue.use(Popover)
Vue.use(Checkbox)
Vue.use(Image)
Vue.use(CheckboxGroup)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Search)
Vue.use(Sticky)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(NumberKeyboard)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Toast)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(NoticeBar)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Col)
Vue.use(Row)
Vue.use(NavBar)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(CellGroup)
Vue.use(Progress)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Calendar)
Vue.use(Lazyload)
Vue.use(Form)
Vue.use(DatetimePicker)
Vue.use(Uploader)
Vue.use(Overlay)
Vue.use(ActionSheet)
Vue.use(Slider)
Vue.use(Cascader)
Vue.use(Switch)
Vue.use(SwipeCell)
Vue.use(Badge)
Vue.use(TreeSelect)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Empty)
Vue.use(Circle)
Vue.use(CountDown)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Skeleton)
Vue.component('CommonLabel', CommonLabel)
Vue.component('BackNav', BackNav)
Vue.component('BackNavStore', BackNavStore)
Vue.component('IconFont', IconFont)
Vue.component('EmptyData', EmptyData)
Vue.component('Message', Message)
Vue.component('SearchNav', SearchNav)

/* 防爆力点击 */
Toast.setDefaultOptions({
  forbidClick: false,
})
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$notify = Notify
Vue.prototype.$downloadUrl = downloadUrl
Vue.prototype.$formatterNum = formatterNum
Vue.prototype.$checkIsEmpty = checkIsEmpty
